import { apiClient } from '~/shared/api/data-ingestion-api'
import { CONSIGNMENT_SERVER_STATUS } from '../config'

export function getConsignmentStatus({
  status,
  hasReviewer,
}: {
  status: apiClient.ReviewStatusEnum
  hasReviewer: boolean
}): 'awaiting' | 'inProgress' | 'finished' | 'rejected' | 'returned' {
  if (status === CONSIGNMENT_SERVER_STATUS.pending) {
    if (hasReviewer) {
      return 'inProgress'
    }
    return 'awaiting'
  }
  if (
    status === CONSIGNMENT_SERVER_STATUS.reviewed ||
    status === CONSIGNMENT_SERVER_STATUS.auto_reviewed
  ) {
    return 'finished'
  }
  return 'rejected'
}
